import React from 'react';
import { useSelector } from 'react-redux';
import { Stack } from 'tamagui';
import DropdownMenu from './DropdownMenu';
const baseItems = [{
  name: 'Home',
  link: '/'
}, {
  name: 'Quizzes',
  link: '/quizzes/'
}, {
  name: 'Dictionary',
  link: '/dictionary/'
}, {
  name: 'Study',
  children: [{
    name: 'Word List',
    link: '/wordlist/'
  }, {
    name: 'Sentence List',
    link: '/sentencelist/'
  }, {
    name: 'Bookmarks',
    link: '/bookmarks/'
  }, {
    name: 'Statistics',
    link: '/statistics/'
  }]
}, {
  name: 'Account',
  children: [{
    name: 'Settings',
    link: '/settings/'
  }, {
    name: 'Blog',
    link: '/blog/'
  }, {
    name: 'Contact',
    link: '/contact/'
  }]
}];
const profileItem = {
  name: 'Profile',
  link: '/profile/'
};
const HeaderContent = () => {
  const profile = useSelector(state => state.profile);
  const dropdownItems = React.useMemo(() => {
    if (profile) {
      const accountIndex = baseItems.findIndex(item => item.name === 'Account');
      if (accountIndex !== -1) {
        const updatedItems = [...baseItems];
        updatedItems[accountIndex] = {
          ...updatedItems[accountIndex],
          children: [...updatedItems[accountIndex].children, profileItem]
        };
        return updatedItems;
      }
    }
    return baseItems;
  }, [profile]);
  if (dropdownItems.length === 0) {
    return /*#__PURE__*/React.createElement(Stack, null);
  }
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    items: dropdownItems,
    childSize: 35
  });
};
export default HeaderContent;